import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { HomeIcon } from "@heroicons/react/24/solid";
import { Fragment, useEffect, useState } from "react";
import { nonAuthInstance } from "../services/axiosConfig";
import useAuth from "../hooks/useAuth";
import useLoading from "../hooks/useLoading";
import Pagination from "../components/Pagination";
import { formatDate } from "../core/Util";
import { getCouponList, getCouponListCount } from "../services/ api_services";

const pages = [{ name: "회원권 관리", href: "/coupon", current: false }];

export default function Coupon() {
    const stats = [
        { id: 1, name: "총", value: "8,000+" },
        { id: 2, name: "발행 회원권", value: "3%" },
        { id: 3, name: "잔여 회원권", value: "99.9%" },
    ];

    const pageSizes = [20, 50, 100];

    const inputCond = {
        couponNo: "",
        sourceUser: "",
        pageNumber: 0,
        pageSize: 0,
        useCode: "",
    };

    const initCouponCount = {
        total_cnt: 0,
        publish_cnt: 0,
        remain_cnt: 0,
    };

    const couponStates = [
        { id: "", title: "전체" },
        { id: "0001", title: "신규" },
        { id: "0009", title: "사용완료" },
    ];

    const { auth } = useAuth();
    const { setLoading } = useLoading();
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);
    const [cond, setCond] = useState(inputCond);
    const [count, setCount] = useState(initCouponCount);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[0]);

    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

    /**
     * 회원권 조회 API
     * @returns
     */
    const couponList = async (condTmp) => {
        try {
            console.log("cond", cond);
            const response = await getCouponList(condTmp);
            if (response && response.status === 200 && response.data) {
                console.log("response.data: ", response.data);
                response.data.map((item) => {
                    item.source_dt = formatDate(item.source_dt);
                    return item;
                });

                setList(response.data);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    const fetchCouponListCount = async (cond) => {
        try {
            console.log("🚀 ~ getCouponListCount ~ cond:", cond);
            const response = await getCouponListCount(cond);
            console.log("🚀 ~ getCouponListCount ~ response:", response);
            if (response && response.status === 200 && response.data) {
                console.log("response.data: ", response.data);
                setTotalCount(response.data);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    /**
     * 쿠폰 카운트 API
     * @returns
     */
    const couponCount = async () => {
        try {
            let condTmp = cond;
            condTmp.sourceUser = auth.admin_seq;
            condTmp.pageNumber = currentPage;
            condTmp.pageSize = pageSize;
            const response = await nonAuthInstance.post("coupon/totalCount", condTmp);
            if (response.status === 200) {
                console.log("Coupon count response.data: ", response.data);
                setCount(response.data);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    useEffect(() => {
        couponCount();
    }, []);

    useEffect(() => {
        // console.log("currentPage", currentPage);
        onSearch();
    }, [currentPage, pageSize]);

    /**
     * 회원권 조회 함수
     * @returns
     */
    async function onSearch() {
        console.warn("START onSearch ==>");
        setLoading(true);
        // let currentVal = currentPage > 0 ? currentPage - 1 : currentPage;
        let condTmp = cond;
        condTmp.sourceUser = auth.admin_seq;

        condTmp.pageNumber = currentPage;
        condTmp.pageSize = pageSize;
        console.log("currentPage==>", currentPage);
        console.log("pageSize==>", pageSize);
        console.log("🚀 ~ onSearch ~ condTmp:", condTmp);
        couponList(condTmp);
        fetchCouponListCount(condTmp);
        // await couponCount(condTmp);
        setLoading(false);
    }

    /**
     * 엔터키 이벤트
     * @returns
     */
    const handleOnKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch(); // Enter 입력이 되면 클릭 이벤트 실행
        }
    };

    const handleOnSelectPageSize = (pageSize) => {
        console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", pageSize);
        // console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", Number(pageSize));
        setPageSize(Number(pageSize));
    };

    const handleOnSelectCouponState = (index) => {
        // console.log("🚀 ~ handleOnSelectCouponState ~ state:", index);
        // console.log("🚀 ~ handleOnSelectCouponState ~ id:", couponStates[index].id);
        setCond((preVal) => {
            return {
                ...preVal,
                useCode: couponStates[index].id,
            };
        });
    };

    const calculateShowingStartIndex = () => (currentPage - 1) * pageSize + 1;

    return (
        <div>
            <nav className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 w-full" aria-label="Breadcrumb">
                <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
                    <li className="flex">
                        <div className="flex items-center">
                            <a href="/" className="text-gray-400 hover:text-gray-500">
                                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {pages.map((page) => (
                        <li key={page.name} className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <a
                                    href={page.href}
                                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    aria-current={page.current ? "page" : undefined}
                                >
                                    {page.name}
                                </a>
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
            <div className=" bg-gray-900 max-w-full mt-2 max-h-full">
                <div className="mx-auto max-w-full">
                    <div className="bg-gray-900 py-10">
                        <div className="px-4 sm:px-6 lg:px-8">
                            <dl className="mx-auto mt-8 mb-8 grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 text-white sm:mt-8 sm:grid-cols-4 sm:gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-4">
                                {stats.map((stat) => (
                                    <div key={stat.id} className="flex flex-col gap-y-3 border-l border-white/10 pl-6">
                                        <dt className="text-sm leading-6">{stat.name}</dt>
                                        <dd className="order-first text-3xl font-semibold tracking-tight">
                                            {stat.id === 1 ? count.total_cnt : stat.id === 2 ? count.publish_cnt : count.remain_cnt}
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                            <div className=" mt-6 mb-6 flex justify-between items-center">
                                <div className="flex justify-start w-full items-center">
                                    <div className="w-3/12 mr-2">
                                        <input
                                            type="search"
                                            placeholder="회원권 번호를 입력해주세요"
                                            className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                            onChange={(e) => {
                                                setCond((preVal) => {
                                                    return {
                                                        ...preVal,
                                                        couponNo: e.target.value,
                                                    };
                                                });
                                            }}
                                            onKeyDown={handleOnKeyPress}
                                        />
                                    </div>
                                    <div className="w-1/12">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white w-full py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 "
                                            onClick={() => onSearch()}
                                        >
                                            검색
                                        </button>
                                    </div>
                                    <div className="w-5/12 ml-36">
                                        <div className="space-y-4 sm:flex sm:items-center sm:space-x-2 sm:space-y-0">
                                            <label className="w-20 text-start text-sm font-medium text-white">회원권 상태 </label>
                                            <select
                                                id="location"
                                                name="location"
                                                className="w-32 rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                defaultValue={couponStates && couponStates[0].title}
                                                onChange={(e) => handleOnSelectCouponState(e.target.selectedIndex)}
                                            >
                                                {couponStates.map((item) => {
                                                    return <option>{item.title}</option>;
                                                })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="flex items-center justify-between align-middle">
                                    <label className="w-36 text-start text-sm font-medium text-white">조회 개수 </label>
                                    <select
                                        id="location"
                                        name="location"
                                        className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                        defaultValue={pageSizes && pageSizes[0]}
                                        onChange={(e) => handleOnSelectPageSize(e.target.value)}
                                    >
                                        {pageSizes.map((item) => {
                                            return <option>{item}</option>;
                                        })}
                                    </select>
                                </div>
                            </div>

                            <div className="mt-1 flow-root">
                                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                        <table className="min-w-full divide-y divide-gray-700">
                                            <thead>
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        className="w-3 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-white sm:pl-0"
                                                    >
                                                        NO
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        회원권번호
                                                    </th>

                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        생성일
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        보낸 회원
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        받은 회원
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        회원권 상태
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-800">
                                                {list &&
                                                    list.map((data, index) => (
                                                        <tr
                                                        // className="hover:bg-slate-800"
                                                        //key={person.email}
                                                        >
                                                            <td className="w-3 whitespace-nowrap py-4 text-left pl-4 pr-3 text-sm font-medium text-white sm:pl-0">
                                                                {calculateShowingStartIndex() + index}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                {data.coupon_no}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                {data.source_dt}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-300">
                                                                {data.target_user_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-300">
                                                                {data.source_user_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                {data.spec_nm}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Pagination
                onChangeCurrentPage={(val) => setCurrentPage(val)}
                onChangeTotalPages={(val) => setTotalPages(val)}
                totalCount={totalCount}
                itemsPerPage={pageSize}
                // onPageChange={handleOnPageChange}
            />
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                                    <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                                        <button
                                            type="button"
                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                            onClick={() => setOpen(false)}
                                        >
                                            <span className="sr-only">Close</span>
                                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                        </button>
                                    </div>
                                    <div className="sm:flex sm:items-start">
                                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                            <Dialog.Title as="h3" className="leading-6 text-gray-900 text-xs">
                                                {formattedDate}
                                            </Dialog.Title>
                                            <div className="mt-2">
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse flex justify-center">
                                        <ul className="w-full px-16">
                                            <li className="bg-gray-100 text-blue-600 font-bold px-3 py-1 mb-2 flex border-none rounded-lg">
                                                <label>발송인:</label>
                                                <p className="pl-1">홍길동</p>
                                            </li>
                                            <li className="px-2 mb-1 text-sm flex ">
                                                <label>소속:</label>
                                                <p className="pl-1">홍길동</p>
                                            </li>
                                            <li className="px-2 mb-7 text-sm flex">
                                                <label>직급:</label>
                                                <p className="pl-1">홍길동</p>
                                            </li>
                                            <li className="bg-gray-100 text-blue-600 font-bold px-3 py-1 mb-2 flex border-none rounded-lg">
                                                <label>수송인:</label>
                                                <p className="pl-1">홍길서</p>
                                            </li>
                                            <li className="px-2 mb-1 text-sm flex ">
                                                <label>소속:</label>
                                                <p className="pl-1">홍길동</p>
                                            </li>
                                            <li className="px-2 mb-7 text-sm flex">
                                                <label>직급:</label>
                                                <p className="pl-1">홍길동</p>
                                            </li>
                                            <li className="bg-gray-100 text-blue-600 font-bold px-3 py-1 mb-2 flex border-none rounded-lg">
                                                <label>수량</label>
                                            </li>
                                            <li>
                                                <input
                                                    type="number"
                                                    placeholder="수량을 입력해 주세요"
                                                    className="block w-full rounded-md border-0 px-3.5 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
                                                />
                                            </li>
                                            <li className="text-center mt-6">
                                                <button
                                                    type="button"
                                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                                    onClick={() => setOpen(false)}
                                                >
                                                    발송하기
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    );
}
